<template>
  <div class="col-8 page-container">
    <Loading v-if="sharedTestLoading"/>
    <Error v-if="sharedTestLoadError"/>
    <div v-if="sharedTest && !sharedTestLoading && !sharedTestLoadError" id="page-content" class="page-content">
      <TestProfileHeader :sharedTest="sharedTest" :printing="printing" @savePDF="savePDF"/>
      <BloodPressureResults v-if="can('shared.test', 'bp')" :sharedTest="sharedTest" :printing="printing"  @openDicussion="openDicussion"/>
      <BloodPressureStats v-if="can('shared.test', 'bp-stats')" :sharedTest="sharedTest" :printing="printing"/>
      <BloodPressureResultsOverall v-if="can('shared.test', 'bp-overall')" :sharedTest="sharedTest" :printing="printing"/>
      <ArithmiesStats v-if="can('shared.test', 'arithmies')" :sharedTest="sharedTest" :printing="printing"/>
      <HeartRateResult v-if="can('shared.test', 'ecg')" :sharedTest="sharedTest" :printing="printing"  @beforeRender="$emit('beforeRender')" @afterRender="$emit('afterRender')"  @openDicussion="openDicussion"/>

      <DiscussionDialog ref="discussion"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TestProfileHeader from './TestProfileHeader.vue'
import BloodPressureResults from './BloodPressureResults.vue'
import BloodPressureStats from './BloodPressureStats.vue'
import ArithmiesStats from './ArithmiesStats.vue'
import HeartRateResult from './HeartRateResult.vue'
import BloodPressureResultsOverall from './BloodPressureResultsOverall.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'
import DiscussionDialog from './DiscussionDialog.vue'

export default {
  components: {
    TestProfileHeader,
    BloodPressureResults,
    BloodPressureStats,
    ArithmiesStats,
    HeartRateResult,
    BloodPressureResultsOverall,
    Loading,
    Error,
    DiscussionDialog
  },
  props: {
    sharedTest: Object
  },
  data: () => ({
    printing: false
  }),
  computed: {
    ...mapState({
      sharedTestLoading: state => state.test.sharedTest.loading,
      sharedTestLoadError: state => state.test.sharedTest.error
    })
  },
  mounted () {
    this.printing = false
  },
  methods: {
    savePDF: function () {
      this.printing = true

      setTimeout(() => {
        // Get HTML to print from element
        const prtHtml = document.getElementById('page-content').innerHTML

        // Get all stylesheets HTML
        let stylesHtml = ''
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML
        }

        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

        WinPrint.document.write(`<!DOCTYPE html>
        <html dir="rtl">
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`)

        WinPrint.document.close()
        WinPrint.focus()
        setTimeout(() => {
          WinPrint.print()
          WinPrint.close()
          this.printing = false
        }, 1000)
      }, 500)
    },
    openDicussion: function (testUuid, userInfo) {
      this.$refs.discussion.open(testUuid, userInfo)
    }
  }
}
</script>

<style>
.page-container {
  height: calc(100vh - 8.46154rem);
}
</style>



// WEBPACK FOOTER //
// src/views/ResultPage.vue